import { z } from 'zod';
import { idSchema, softDeleteTimestampsSchema } from './common.js';
export const commentBodySchema = z.string().min(1).max(10000);
export const commentSchema = z
    .object({
    id: idSchema,
    taskId: idSchema,
    authorId: idSchema,
    /** Markdown. */
    body: commentBodySchema,
})
    .extend(softDeleteTimestampsSchema.shape);
/** `POST /tasks/{id}/comments` */
export const createCommentRequestSchema = z.object({
    body: commentBodySchema,
});
/** `PATCH /comments/{id}` — solo el autor. */
export const updateCommentRequestSchema = z.object({
    body: commentBodySchema,
});
//# sourceMappingURL=comment.js.map